import { render, staticRenderFns } from "./groupMessageSelector.vue?vue&type=template&id=5082e57a"
import script from "./groupMessageSelector.vue?vue&type=script&lang=js"
export * from "./groupMessageSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports